export const convertTo12Hour = (time) => {
    if (!time) return "";
    let [hours, min] = time.split(":");
    let hour = parseInt(hours);
    let amOrPm = hour < 12 ? "AM" : "PM";
    let stringHour;
    if (hour === 12 && amOrPm === "PM") {
        stringHour = `${hour}`;
    } else {
        stringHour = `${hour % 12}`;
    }

    if (stringHour < 10) {
        stringHour = `0${stringHour}`; /// if the hour value
    }

    return `${stringHour} : ${min} ${amOrPm}`;
};

export const localDateFormatWithMonthName = (date) => {
    if (!date) return "";

    const parseDateTime = new Date(date);

    const formatedDate = new Intl.DateTimeFormat("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
    }).format(parseDateTime);

    return formatedDate;
};

export const localTimeFormat = (date) => {
    if (!date) return "";

    const parseDateTime = new Date(date);

    const formatedDate = new Intl.DateTimeFormat("en-US", {
        hour: "numeric",
        minute: "numeric",
        hour12: true,
    }).format(parseDateTime);

    return formatedDate;
};
export const localDateFormatWithMonthNameInShort = (date) => {
    if (!date) return "";

    const parseDateTime = new Date(date);

    const formatedDate = new Intl.DateTimeFormat("en-US", {
        year: "numeric",
        month: "short",
        day: "numeric",
    }).format(parseDateTime);

    return formatedDate;
};

export const convertToEpocTimeInSecond = (date) => {
    if (!date) return "";

    const parseDateTime = new Date(date);

    /// converting into UTC Time
    const parseUtcDateTime = parseDateTime.toUTCString();

    return Math.floor(new Date(parseUtcDateTime).getTime() / 1000);

};

export const convertToEpocTimeInSecondOfEndDate = (date) => {
    if (!date) return "";

    let parseDateTime = new Date(date);

    parseDateTime = parseDateTime.setDate(parseDateTime.getDate() + 1);

    /// converting into UTC Time
    const parseUtcDateTime = new Date(parseDateTime).toUTCString();

    return Math.floor(new Date(parseUtcDateTime).getTime() / 1000);
};
